const NEW_BANNER_WITH_IMAGE_BLOCK_DATA = {
  firstTitle: [{
    id: 1,
    text: 'First title',
    textMob: 'First title',
    secondText: 'desktop default',
    secondTextMob: 'mobile default',
    isTextReverse: true,
    isTextReverseMob: true,
    isTextColumn: false,
    isTextColumnMob: true,
    isLeft: false,
    isLeftMob: false,
    isRight: true,
    isRightMob: false,
    color: '#ffffff',
    colorMob: '#ffffff',
    isTextWithLine: false,
    isTextWithLineMob: true,
    isSecondTextWithLine: false,
    isSecondTextWithLineMob: true,
    firstTextLines: [{
      id: 1,
      isLeftLine: false,
      isRightLine: false,
      isTopLine: false,
      isBottomLine: false,
      color: '#ffffff',
      isLineWithSquare: false,
      isLeftLineMob: true,
      isRightLineMob: false,
      isTopLineMob: false,
      isBottomLineMob: true,
      colorMob: '#ffffff',
      isLineWithSquareMob: true,
    }],
    secondTextLines: [{
      id: 1,
      isLeftLine: false,
      isRightLine: false,
      isTopLine: false,
      isBottomLine: false,
      color: '#eec586',
      isLineWithSquare: false,
      isLeftLineMob: false,
      isRightLineMob: true,
      isTopLineMob: false,
      isBottomLineMob: false,
      colorMob: '#eec586',
      isLineWithSquareMob: true,
    }],
  }],
  secondTitle: [
    {
      id: 1,
      text: '',
      textMob: 'Second title',
      secondText: 'Second title desktop default',
      secondTextMob: 'mobile default',
      isTextReverse: true,
      isTextReverseMob: true,
      isTextColumn: false,
      isTextColumnMob: true,
      isLeft: false,
      isLeftMob: false,
      isRight: false,
      isRightMob: true,
      color: '#293241',
      colorMob: '#ffffff',
      isTextWithLine: false,
      isTextWithLineMob: true,
      isSecondTextWithLine: false,
      isSecondTextWithLineMob: true,
      firstTextLines: [{
        id: 1,
        isLeftLine: false,
        isRightLine: false,
        isTopLine: false,
        isBottomLine: false,
        color: '#eec586',
        isLineWithSquare: false,
        isLeftLineMob: true,
        isRightLineMob: false,
        isTopLineMob: false,
        isBottomLineMob: false,
        colorMob: '#eec586',
        isLineWithSquareMob: true,
      }],
      secondTextLines: [],
    },
  ],
  description: '',
  descriptionMobile: '',
  buttonText: '',
  buttonTextMobile: '',
  isRight: false,
  isDarkButton: false,
  buttonLink: '',
  mediaData: {
    isVideo: false,
    src: '',
    srcMobile: '',
  },
};

export default NEW_BANNER_WITH_IMAGE_BLOCK_DATA;
